import { requestTimeout, handleResponse } from "../utils";

const apiUrl = process.env.REACT_APP_API_URL;
const apiMaxTime = process.env.REACT_APP_API_EXEC_TIME;

export const dashboardApi = {
  _get,
};

async function _get() {
  const token = localStorage.getItem(process.env.REACT_APP_AUTH_COOKIE);
  const requestOptions = {
    method: "GET",
    credentials: "include",
    headers: {
      Authorization: "Bearer " + token,
      "Content-Type": "application/json",
      Accept: "application/json",
    },
  };
  return requestTimeout(
    apiMaxTime,
    fetch(apiUrl + "account/user-dashboard", requestOptions)
  )
    .then(handleResponse)
    .then((response) => {
      return response;
    });
}
